module.exports = __webpack_public_path__ + "static/img/img1.cfcc4d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/puzzleImg/img1.jpg
// module id = 3i4D
// module chunks = 1